import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { Observable } from 'rxjs';

@Injectable()
export class PedidoPecasServiceService {

  private baseUrlService: string;

  constructor(private http: HttpClient) {
    this.baseUrlService = environment.URL_API + '/PedidoPecas/listar'
  }

  getLista(dealers?: any, data_inicial?: any, data_final?: any, pedido_status?: any, codigo_item?: any,
    numero_interno?: any, numero_fornecedor?: any): Observable<any> {

    return this.http.get<any>(`${this.baseUrlService}`, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': JSON.parse(sessionStorage.getItem('currentUser')).token
      }),
      params: new HttpParams()
        .set('data_inicial', data_inicial.toString())
        .set('data_final', data_final.toString())
        .set('dealers', dealers.toString())
        .set('pedido_status', pedido_status.toString())
        .set('codigo_item', codigo_item.toString())
        .set('numero_interno', numero_interno.toString())
        .set('numero_fornecedor', numero_fornecedor.toString())
    });
  }
}
